import { connect } from "react-redux";
import CreatePasswordPage from "../components/authUI/CreatePasswordPage";
import {updatePassword} from "../store/actions/authActions"

const mapStatetoProps = (state) =>({
    //add state here
    email: state.auth.email,
    affiliateCode: state.auth.affiliateCode,
})

const CreatePasswordContainer = connect(
    mapStatetoProps, {updatePassword}
)(CreatePasswordPage)

export default CreatePasswordContainer